// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"962ff253","137":"346c1f57","295":"64f85938","431":"c4fb0a33","479":"e8911645","485":"5e13d2d1","703":"2618e838","790":"66c48a92","856":"525df6cd"}[chunkId] + ".chunk.js";
};